import { useTranslation } from 'react-i18next';
import { useLearning } from 'src/hook/data/useLearning';
import useUser from 'src/hook/data/useUser';
import { useIFrameModal } from 'src/hook/modal/useIFrameModal';
import Person from 'src/model/People';
import { GetRazorSiteUrl, IconLocation } from 'src/utils/URLUtils';
import styles from './FantasySection.module.scss';

export const FantasySection = () => {
    const { learningInfo } = useLearning();
    const { userInfo } = useUser();
    const { open } = useIFrameModal();
    const { t, i18n } = useTranslation();

    const handleClick = (personId: number, personText: string) => {

        if (personId === 0) {
            open(GetRazorSiteUrl(`profile/people-selection`,
                userInfo?.Token)
                , `Favourite People`);
        }
        else {
            open(GetRazorSiteUrl(`practice/fantasy-chat`,
                userInfo?.Token, `&personId=${personId}`)
                , personText);
        }
    }

    return (
        <section className={styles.fantasySection}>
            <h2 className='homeTitle'>{t('Fantasy Chat')}</h2>
            <p dir={i18n.dir()} className='homeSubtitle'>{t('Practice with your favourite people with AI roleplay!')}</p>

            <div className={styles.grid}>
                {learningInfo?.People.slice(0, 7).map((person: Person) => (
                    <div key={person.Id}
                        onClick={() => handleClick(person.Id, person.Text)}
                        className={styles.card}>
                        <img src={person.Icon} alt={person.Text} loading='lazy' />
                        <span className={person.Text.length > 15 ? styles.small : ''}>{person.Text}</span>
                    </div>
                ))}
                <div className={styles.card}
                    onClick={() => handleClick(0, 'Lexi')}>
                    <img src={IconLocation('celeb-more')} alt="More" loading='lazy' />
                    <span>{t('More')}</span>
                </div>
            </div>
        </section>
    );
};
